<div class="flex flex-col justify-center items-center mt-4 text-blue1"
     *transloco="let t; read: 'user.subscription'">
  <psc-loader *ngIf="loading"></psc-loader>
  <div *ngIf="redirectedFromPayment" class="my-2 font-bold flex items-center">
    <mat-icon class="text-green-700 mr-2">check_circle</mat-icon>
    {{t('payment_success')}}
  </div>
  <div class="flex flex-col md:flex-row w-full justify-center gap-14" *ngIf="!loading">

    <psc-transactions-table class="w-full md:w-1/2"
                            [transactions]="subscription ? subscription.transactionList : []"></psc-transactions-table>

    <div class="px-4 w-full md:w-1/3">
      <div class="rounded-xl bg-sun-yellow bg-opacity-10 p-8 flex justify-between gap-14">
        <div class="flex flex-col gap-4">
          <div
            class="font-bold text-2xl col-span-2">
            <ng-container [ngSwitch]="userRole">
              <ng-container *ngSwitchCase="UserRole.ROLE_BUSINESS">
                {{t('plan.business')}}
              </ng-container>
              <ng-container *ngSwitchCase="UserRole.ROLE_BUSINESS_PLUS">
                {{t('plan.business_plus') }}
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{t('plan.no_plan') }}
              </ng-container>

            </ng-container>
          </div>

          <div class="font-bold"
               *ngIf="subscription.totalAmount">
            {{subscription.totalAmount || '-'}} {{subscription.currency}} / {{t('monthly')}}
          </div>

          <div>
            <div class="font-bold">{{t('expiration')}}:</div>
            <div>{{(subscription.subscriptionExpiry | date:'dd.MM.yyyy.') || '-'}}</div>
          </div>

          <div>
            <div class="font-bold">{{t('payment_due')}}:</div>
            <div>{{subscription.autoRenewalActive ? (subscription.paymentDueDate | date:'dd.MM.yyyy.') : t('auto_renewal_inactive')}}</div>
          </div>
        </div>
        <div class="flex gap-4 flex-col justify-end">
          <div class="flex flex-col gap-4 items-end">
            <psc-button
              *ngIf="(([UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_PLUS] | userHasRole) && !subscription.autoRenewalActive) || ([UserRole.ROLE_BUSINESS_EXP, UserRole.ROLE_BUSINESS_PLUS_EXP] | userHasRole)"
              size="small"
              (buttonClicked)="toggleSubscribeDialog()"
              [label]="t('subscribe')"></psc-button>
            <ng-container
              *ngIf="([UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_PLUS] | userHasRole) && subscription.autoRenewalActive">
              <psc-button
                size="small"
                (buttonClicked)="toggleChangePlanDialog()"
                [label]="t('change_plan')"></psc-button>
              <psc-button
                type="primary-magenta"
                (buttonClicked)="cancelSub()"
                size="small"
                [label]="t('cancel_sub')"></psc-button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <psc-dialog
    *ngIf="showChangePlanDialog"
    [title]="t('change_plan')"
    (closeClicked)="toggleChangePlanDialog()">
    <div
      class="text-gray-700 font-bold py-2 text-center">
      <ng-container *pscRoleAccess="[UserRole.ROLE_BUSINESS]">{{t('change_plan_info.to_higher')}}</ng-container>
      <ng-container *pscRoleAccess="[UserRole.ROLE_BUSINESS_PLUS]">{{t('change_plan_info.to_lower')}}</ng-container>
    </div>
    <psc-plan-selection
      [subscription]="subscription"
      (planSelected)="changePlan($event)"></psc-plan-selection>
  </psc-dialog>
  <psc-dialog
    *ngIf="showSubscribeDialog"
    [title]="t('choose_plan')"
    (closeClicked)="toggleSubscribeDialog()">
    <div
      class="text-gray-700 font-bold py-2 text-center"
      *pscRoleAccess="[UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_PLUS]">
      {{t('due_date_info')}}
    </div>
    <psc-plan-selection
      [subscription]="subscription"
      (planSelected)="subscribe($event)"></psc-plan-selection>
  </psc-dialog>
</div>
